import React from "react";
import { Button } from "react-bootstrap";
import FiChevronUp from "../../../../constants/icons/Fi/FiChevronUp";
import FiChevronDown from "../../../../constants/icons/Fi/FiChevronDown";
import withSubscriptionCheckButton from "../../../../components/Common/withSubscriptionCheckButton";
import TopicItem from "./TopicItem";
import { getMasteryStatus, getMasteryText } from "../utils";

const ViewButton = withSubscriptionCheckButton(
  Button,
  "Practice",
  true,
  false,
  "student-practice-view-attempts my-0"
);

const MobileView = ({
  sectionsList,
  selectedSections,
  setSelectedSections,
  selectedMobileTopic,
  setSelectedMobileTopic,
  roleOfTheUser,
  classroomId,
  activeTab,
  hasValidSubscription,
  onViewAllAttempts,
  isLoading,
  classroomLoader,
  handlePracticeStart,
}) => {
  return (
    <div
      className="d-block d-lg-none col-12"
      style={{
        marginTop: "15px",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      {sectionsList?.length && selectedMobileTopic?.length ? (
        <div className="d-flex justify-content-start align-items-center my-2">
          {roleOfTheUser === "Student" ? (
            <ViewButton
              onClick={onViewAllAttempts}
              classRoomId={classroomId}
              requiredFeature="Practice"
              hasValidSubscription={hasValidSubscription}
              subjects={[activeTab]}
              index={0}
            >
              View Attempts
            </ViewButton>
          ) : (
            <Button
              className="student-practice-view-attempts my-0"
              onClick={onViewAllAttempts}
            >
              View Attempts
            </Button>
          )}
        </div>
      ) : (
        ""
      )}
      <div className="p-0 bg-white">
        {!isLoading && !classroomLoader && sectionsList?.length ? (
          sectionsList.map((section, index) => {
            const isSelected = selectedSections.some(
              (selec) => selec === section?._id
            );
            return (
              <div key={index}>
                <div
                  className="d-flex justify-content-between"
                  style={{
                    background: "#F5F7FA",
                    border: "1px solid #E9EAF0",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "22px",
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                      color: "#564FFD",
                    }}
                    onClick={() => {
                      if (isSelected) {
                        setSelectedSections(
                          selectedSections.filter(
                            (selec) => selec !== section?._id
                          )
                        );
                      } else {
                        setSelectedSections([
                          ...selectedSections,
                          section?._id,
                        ]);
                      }
                    }}
                  >
                    {isSelected ? (
                      <FiChevronUp
                        size={20}
                        style={{ marginRight: "8px", cursor: "pointer" }}
                      />
                    ) : (
                      <FiChevronDown
                        size={20}
                        style={{ marginRight: "8px", cursor: "pointer" }}
                      />
                    )}{" "}
                    {section?.name}
                  </div>
                </div>
                {isSelected ? (
                  section?.topics?.length ? (
                    <div className="py-2">
                      {section?.topics?.map((topic, index) => {
                        const isTopicSelected = selectedMobileTopic.some(
                          (selec) => selec === topic?._id
                        );
                        // Compute badge logic (copied from TopicItem)
                        const isValidScore = (score) =>
                          typeof score === "number" && !isNaN(score);
                        const allPracticesAttempted = Array.isArray(
                          topic?.practices
                        )
                          ? topic.practices.length > 0 &&
                            topic.practices.every((p) => isValidScore(p.score))
                          : true;
                        const allTestsAttempted = Array.isArray(topic?.tests)
                          ? topic.tests.length > 0 &&
                            topic.tests.every((t) => isValidScore(t.score))
                          : true;
                        const hasAnySets =
                          (Array.isArray(topic?.practices) &&
                            topic.practices.length > 0) ||
                          (Array.isArray(topic?.tests) &&
                            topic.tests.length > 0);
                        const allAttempted =
                          hasAnySets &&
                          allPracticesAttempted &&
                          allTestsAttempted;
                        const topicScore =
                          typeof topic.score === "string"
                            ? parseFloat(topic.score)
                            : topic.score;
                        let badge = null;
                        if (allAttempted) {
                          if (topicScore >= 90) badge = "Champion";
                          else if (topicScore > 60 && topicScore < 90)
                            badge = "Challenger";
                          else badge = "Rookie";
                        } else {
                          if (topicScore > 60) badge = "Challenger";
                          else badge = "Rookie";
                        }
                        return (
                          <div key={index}>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              style={{
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "22px",
                                letterSpacing: "-0.01em",
                                textAlign: "left",
                                color: "#4E5566",
                                padding: "12px 20px 12px 20px",
                                border: "1px solid #F5F7FA",
                              }}
                              onClick={() => {
                                if (isTopicSelected) {
                                  setSelectedMobileTopic(
                                    selectedMobileTopic.filter(
                                      (selec) => selec !== topic?._id
                                    )
                                  );
                                } else {
                                  setSelectedMobileTopic([
                                    ...selectedMobileTopic,
                                    topic?._id,
                                  ]);
                                }
                              }}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <div>{topic?.name}</div>
                                {badge && (
                                  <span
                                    className={`topic-badge ${badge.toLowerCase()}`}
                                  >
                                    {badge}
                                  </span>
                                )}
                                {topic?.masteryScore !== undefined && (
                                  <span
                                    className={`topic-mastery-badge ${getMasteryStatus(
                                      topic.masteryScore
                                    )}`}
                                  >
                                    {getMasteryText(topic.masteryScore)} (
                                    {topic.masteryScore}%)
                                  </span>
                                )}
                              </div>
                              <div>
                                {isTopicSelected ? (
                                  <FiChevronUp size={20} />
                                ) : (
                                  <FiChevronDown size={20} />
                                )}
                              </div>
                            </div>
                            {isTopicSelected && (
                              <TopicItem
                                topic={topic}
                                roleOfTheUser={roleOfTheUser}
                                classroomId={classroomId}
                                activeTab={activeTab}
                                hasValidSubscription={hasValidSubscription}
                                onPracticeStart={handlePracticeStart}
                                isMobile={true}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="p-4">
                      No topics present in this section.
                    </div>
                  )
                ) : (
                  ""
                )}
                <div style={{ border: "1px solid #E9EAF0" }} />
              </div>
            );
          })
        ) : !isLoading && !classroomLoader && sectionsList?.length === 0 ? (
          <div className="p-4">No sections present in this subject.</div>
        ) : null}
      </div>
    </div>
  );
};

export default MobileView;
